export enum HolidayType {
ByLaw,
Company,
}
